export default "__VITE_ASSET__Cgx5DOXO__"